// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Pmkl","topBottomGutter":"Layout_topBottomGutter__2JUFq"};